require('core-js/modules/web.dom-collections.iterator');

/**
 * This function is a callback for the datastore sdk where a JWT is needed to be fetched for each component
 * @param {string} tokenEndpoint - The JWT token endpoint, to fetch the token from
 * @returns {string} returns the JWT as a string
 */
// eslint-disable-next-line consistent-return
async function getJWT(tokenEndpoint) {
    // If the user is offline then we should just return a dummy JWT
    if (!navigator.onLine) {
        return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21tZW50IjoidGhpcyBpcyBhIGR1bW15IEpXVCB1c2VkIGZvciBTREsgdmFsaWRhdGlvbiB3aGlsZSBvZmZsaW5lLiJ9.41wRTE4EiHkCVYztCDlpik_BmuuHKK_ZyNzIm4xcEb4';
    }

    const endpointName = JSON.stringify(tokenEndpoint);

    const cookies = document.cookie.split('; ').map((cookie) => {
        const [name, value] = cookie.split('=');
        return { name, value };
    });

    const endpointCookie = cookies.find(({ name }) => name === endpointName);

    if (endpointCookie) {
        return endpointCookie.value;
    }

    const jwtResponse = await fetch(tokenEndpoint, {
        method: 'POST',
        credentials: 'include',
    });

    const jwtContents = await jwtResponse.text();

    const cacheControlHeader = jwtResponse.headers.get('cache-control');
    const [, maxAge] = cacheControlHeader ? cacheControlHeader.split(', ') : [];

    document.cookie = `${endpointName}=${jwtContents};${maxAge}`;

    return jwtContents;
}

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.default = getJWT;
